module.exports = __webpack_public_path__ + "static/img/index-title-01.2aa5f05e.png";